module.exports = __webpack_public_path__ + "img/module_tfoms.cf2c8b18.jpeg";